export const handleBarAnimation = () => {
	$('.bar-progress-full').each(function() {
		$(this).addClass('bar-animation')
	})
}
